import React from 'react';
import PropTypes from 'prop-types';

import Popup from '../Popup';
import TextMessage from '../../Ui/TextMessage';

const getLocalizationData = string => {
  if (!string) return null;
  return { id: string };
};

const SimpleInfoPopup = ({
  icon,
  width,
  opened,
  onClick,
  titleId,
  messageId,
  buttonTitleId,
  iconClassName,
  buttonClassName,
  children,
  ...other
}) => (
  <Popup opened={opened} width={width} {...other}>
    <TextMessage
      icon={icon}
      iconClassName={iconClassName}
      buttonClassName={buttonClassName}
      title={getLocalizationData(titleId)}
      message={getLocalizationData(messageId)}
      buttonTitle={getLocalizationData(buttonTitleId)}
      onClick={onClick}
    />
    {children}
  </Popup>
);

SimpleInfoPopup.propTypes = {
  icon: PropTypes.string,
  width: PropTypes.string,
  titleId: PropTypes.string,
  opened: PropTypes.bool,
  onClick: PropTypes.func,
  messageId: PropTypes.string,
  buttonTitleId: PropTypes.string,
  buttonClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.number,
    PropTypes.string,
  ]),
};

export default SimpleInfoPopup;



// WEBPACK FOOTER //
// ./src/components/common/SimpleInfoPopup/index.jsx